<template>
  <div v-bind:class="{ 'form-group': true, 'has-error': this.m_error !== null }">
    <label>{{ field.label }}</label>
    <div class="input-group">
      <div class="input-group-addon">R$</div>
      <vue-autonumeric
        v-model="m_fieldAnswer.value"
        :options="['Brazilian', { currencySymbol: '', emptyInputBehavior: 'null',  minimumValue: '0' }]"
        class="form-control"
        :disabled="disabledAttribute"
      ></vue-autonumeric>
    </div>
  </div>
</template>

<script>
  import VueAutonumeric from 'vue-autonumeric'

  export default {
    components: {VueAutonumeric},
    props: ['field', 'fieldAnswer', 'isDisabled'],
    name: 'EmailField',
    data () {
      return {
        m_fieldAnswer: {
          fieldUuid: this.field.uuid,
          value: this.fieldAnswer.value
        },
        m_error: null,
        m_rowIndex: this.fieldAnswer.rowIndex
      }
    },
    computed: {
      disabledAttribute () {
        return this.field.disabled === true || this.isDisabled === true
      }
    },
    watch: {
      'm_fieldAnswer.value' () {
        this.$emit('fieldUpdated', this.m_rowIndex, this.m_fieldAnswer)
      }
    },
    methods: {
      isValid () {
        if (this.field.required && !this.m_fieldAnswer.value && this.m_fieldAnswer.value !== 0) {
          this.m_error = true
          return false
        }

        this.m_error = null
        return true
      }
    }
  }
</script>



// WEBPACK FOOTER //
// MoneyField.vue?0b48f3a2